var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ml-table',{attrs:{"columns":_vm.tableColumns,"data-source":_vm.dataValue.alarmInfoList,"scroll":{ x: (100 * _vm.columns.length), y: 240}}})}
var staticRenderFns = []

export { render, staticRenderFns }